<!-- <div class="product">
    <div class="easyzoom easyzoom--overlay main-img" [ngClass]="{loading:!loadAvatar}">
        <img [src]="product.avatar|absolutePath:'products'"
            [attr.data-zoom-image]="product.avatar|absolutePath:'products'" [hidden]="!loadAvatar"
            (load)="loadAvatar=true" [alt]="product.name +' en livraison'" />
    </div>
    <div class="body">
        <span>
            <h4>{{product.name}}</h4>
        </span>
        <div class="price">
            <span> {{product.sizes[product.size].price|plus:product.supplement}}€</span>
        </div>
        <table width="100%">
            <tr>
                <td width="55%">
                    <select class="form-control" [(ngModel)]="product.size" *ngIf="product.sizes.length>1">
                        <opti  on *ngFor="let s of product.sizes;let j=index" [value]="j">{{s.size}}</option>
                    </select>
                    <p *ngIf="product.sizes.length==1 && product.sizes[0].level!=0">{{product.sizes[0].size}}</p>
                </td>
                <td>
                    <ng-container *ngIf="product.validPeriod==1">
                        <div class="pull-right" *ngIf="product.sizes[product.size]?.available">
                            <button (click)="addToBasket()" class="btn col-xs-12 add" [disabled]="siteClose">
                                Ajouter
                            </button>
                        </div>
                        <div class="pull-right" *ngIf="!product.sizes[product.size].available">
                            <div class="col-xs-12 indisponible">
                                <div class="alert alert-danger text-center">
                                    Indisponible
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div class="pull-right" *ngIf="product.validPeriod==0">
                        <div class="col-xs-12 indisponible">
                            <div *ngIf="product.elementTime==1" class="alert alert-danger text-center">
                                Disponible midi
                            </div>
                            <div *ngIf="product.elementTime==3" class="alert alert-danger text-center">
                                Disponible soir
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div> -->
<div class="card">
    <div class="avatar" [ngStyle]="{'background-image':'url('+(product.avatar|absolutePath:'products')+')'}">
    </div>
    <div class="infos">
        <div class="name">
            {{product.name|uppercase}}
        </div>
        <div class="sizes">
            <select class="form-control" [(ngModel)]="product.size" *ngIf="product.sizes.length>1">
                <option *ngFor="let s of product.sizes;let j=index" [value]="j">{{s.size}}</option>
            </select>
            <p *ngIf="product.sizes.length==1 && product.sizes[0].level!=0">{{product.sizes[0].size}}</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="price">
                {{product.sizes[product.size].price}} €
            </div>
            <div *ngIf="!product.sizes[product.size].available" class="indisponible">
                <div class="alert alert-danger text-center">
                    <span *ngIf="!product.sizes.length>1">Taille</span> Indisponible
                </div>
            </div>
            <ng-container *ngIf="product.sizes[product.size].available">
                <ng-container *ngIf="product.validPeriod==1">
                    <button (click)="addToBasket()" [disabled]="siteClose"
                        class="btn btn-block btn-danger align-items-center d-flex btn-sm mr-2"
                        *ngIf="product.sizes[product.size]?.available">
                        <img class="mr-4" width="25px" src="assets/images/addBasket.png" alt="commander">
                        <span>Ajouter</span>
                    </button>
                </ng-container>
                <ng-container *ngIf="product.validPeriod==0">
                    <div class="indisponible">
                        <div *ngIf="product.elementTime==1" class="alert alert-danger text-center">
                            Disponible midi
                        </div>
                        <div *ngIf="product.elementTime==3" class="alert alert-danger text-center">
                            Disponible soir
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>